export let InformationModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                child: [
                  {
                    parentid: "1719381237579-col-1",
                    elementid: "1719381241192",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1719381237579-columns",
                elementid: "1719381237579-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1719381237579-col-2",
                    elementid: "1719381246009",
                    elementtype: "customSelect",
                  },
                ],
                colpos: 2,
                parentid: "1719381237579-columns",
                elementid: "1719381237579-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1719381237579-col-2",
                    elementid: "1717412405877",
                    elementtype: "documentFile",
                  },
                ],
                colpos: 2,
                parentid: "1719381237579-columns",
                elementid: "1719381237579-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1719381237579-col-2",
                    elementid: "1717412405888",
                    elementtype: "documentFile",
                  },
                ],
                colpos: 2,
                parentid: "1719381237579-columns",
                elementid: "1719381237579-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1719381221960-fieldset-body",
            elementid: "1719381237579",
            elementtype: "columns",
          },
        ],
        parentid: "section-1719381217587-form",
        elementid: "1719381221960",
        elementtype: "fieldset",
      },
      {
        child: [
          {
            child: [
              {
                child: [
                  {
                    parentid: "1719381275577-col-1",
                    elementid: "1719381288490",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1719381275577-columns",
                elementid: "1719381275577-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1719381275577-col-2",
                    elementid: "1719381292523",
                    elementtype: "textfield",
                  },
                ],
                colpos: 2,
                parentid: "1719381275577-columns",
                elementid: "1719381275577-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1719381266926-fieldset-body",
            elementid: "1719381275577",
            elementtype: "columns",
          },
          {
            child: [
              {
                child: [
                  {
                    parentid: "1719381280207-col-1",
                    elementid: "1719381296940",
                    elementtype: "number",
                  },
                ],
                colpos: 1,
                parentid: "1719381280207-columns",
                elementid: "1719381280207-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [
                  {
                    parentid: "1719381280207-col-2",
                    elementid: "1719381302373",
                    elementtype: "textfield",
                  },
                ],
                colpos: 2,
                parentid: "1719381280207-columns",
                elementid: "1719381280207-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1719381266926-fieldset-body",
            elementid: "1719381280207",
            elementtype: "columns",
          },
          {
            child: [
              {
                child: [
                  {
                    parentid: "1719381283974-col-1",
                    elementid: "1719381306940",
                    elementtype: "textfield",
                  },
                ],
                colpos: 1,
                parentid: "1719381283974-columns",
                elementid: "1719381283974-col-1",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
              {
                child: [],
                colpos: 2,
                parentid: "1719381283974-columns",
                elementid: "1719381283974-col-2",
                elementtype: "column",
                colsizeclass: "col-md-6",
              },
            ],
            colsize: 2,
            parentid: "1719381266926-fieldset-body",
            elementid: "1719381283974",
            elementtype: "columns",
          },
        ],
        parentid: "section-1719381217587-form",
        elementid: "1719381266926",
        elementtype: "fieldset",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1719381217587",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let UploadLayoutJSON = [
  {
    name: "New",
    child: [
      {
        parentid: "section-1720177232612-form",
        elementid: "1717412405877",
        elementtype: "documentFile",
      },
      {
        parentid: "section-1720177232612-form",
        elementid: "1717412405888",
        elementtype: "documentFile",
      },
    ],

    parentid: "myTabContent",
    elementid: "section-1720177232612",
    description: "",
    elementtype: "section",
    "section-type": "form",
    linkedentitytype: -1,
  },
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1720177232612-col-1",
                elementid: "1717412405877",
                elementtype: "file",
              },
            ],
            colpos: 1,
            parentid: "1720177232612-columns",
            elementid: "1720177232612-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let CompanyModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1692362019775-col-1",
                elementid: "1719381241192",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1717412405877",
                elementtype: "documentFile",
              },
            ],
            colpos: 1,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719381246009",
                elementtype: "select",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1717412405888",
                elementtype: "documentFile",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];

export let PrimaryModalLayoutJSON = [
  {
    name: "New",
    child: [
      {
        child: [
          {
            child: [
              {
                parentid: "1692362019775-col-1",
                elementid: "1719381288490",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1719381296940",
                elementtype: "number",
              },
              {
                parentid: "1692362019775-col-1",
                elementid: "1719381306940",
                elementtype: "textfield",
              },
            ],
            colpos: 1,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-1",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
          {
            child: [
              {
                parentid: "1692362019775-col-2",
                elementid: "1719381292523",
                elementtype: "textfield",
              },
              {
                parentid: "1692362019775-col-2",
                elementid: "1719381302373",
                elementtype: "textfield",
              },
            ],
            colpos: 2,
            parentid: "1692362019775-columns",
            elementid: "1692362019775-col-2",
            elementtype: "column",
            colsizeclass: "col-md-6",
          },
        ],
        colsize: 2,
        parentid: "section-1692362014074-form",
        elementid: "1692362019775",
        elementtype: "columns",
      },
    ],
    parentid: "myTabContent",
    elementid: "section-1692362014074",
    description: "",
    elementtype: "others",
    "section-type": "form",
    linkedentitytype: -1,
  },
];
